import { createStore } from 'vuex';
import Axios from 'axios';
import { nextTick } from 'vue';
const SetUser = (state, params) => {
    params = params || {};
    state.user = params;
    localStorage.setItem("USER", JSON.stringify(params));
};
export default createStore({
    state: {
        params: {},
        token: localStorage.getItem("AUTH_TOKEN"),
        refreshToken: localStorage.getItem("REFRESH_TOKEN"),
        user: JSON.parse(localStorage.getItem("USER") || "{}"),
        router: undefined,
        routes: JSON.parse(sessionStorage.getItem("OLYMPUS_ROUTES") || "[]"),
        localRoutes: JSON.parse(sessionStorage.getItem("OLYMPUS_LOCAL_ROUTES") || "[]"),
        path: "/",
        appLoading: true,
        contentTypes: JSON.parse(sessionStorage.getItem("OLYMPUS_WC_CONTENT_TYPES") || "{}"),
        reportGroups: JSON.parse(localStorage.getItem("rg") || "[]"),
        dragging: false,
        admin: true,
        editing: false
    },
    mutations: {
        SET_PARAMS(state, params) {
            state.params = params;
        },
        SET_USER(state, params) {
            SetUser(state, params);
        },
        SET_LOADING(state, loading) {
            state.appLoading = loading;
        },
        SET_ROUTER(state, router) {
            state.router = router;
        },
        SET_ROUTES(state, routes) {
            state.routes = routes;
            //sessionStorage.setItem("OLYMPUS_ROUTES", JSON.stringify(routes));
        },
        SET_LOCAL_ROUTES(state, routes) {
            state.localRoutes = routes;
            //sessionStorage.setItem("OLYMPUS_LOCAL_ROUTES", JSON.stringify(routes));
        },
        SET_PATH(state, path) {
            state.path = path;
        },
        SET_CONTENT_TYPES(state, contentTypes) {
            state.contentTypes = contentTypes;
            sessionStorage.setItem("OLYMPUS_WC_CONTENT_TYPES", JSON.stringify(contentTypes));
        },
        SET_DRAGGING(state, result) {
            state.dragging = result;
        },
        TOGGLE_ADMIN(state) {
            state.admin = !state.admin;
        },
        TOGGLE_EDITING(state) {
            state.editing = !state.editing;
        },
        SET_REPORTGROUPS(state, groups) {
            state.reportGroups = groups;
            localStorage.setItem("rg", JSON.stringify(groups));
        }
    },
    actions: {
        setParams: ({ commit, state }, params) => {
            commit("SET_PARAMS", params);
        },
        login: ({ commit, state }, params) => {
            commit("SET_USER", params);
        },
        logout: ({ commit, state }) => {
            commit("SET_USER", null);
        },
        setLoading: ({ commit, state }, loading) => {
            commit("SET_LOADING", loading);
        },
        setRouter: ({ commit, state }, router) => {
            commit("SET_ROUTER", router);
        },
        setRoutes: ({ commit, state }, routes) => {
            commit("SET_ROUTES", routes);
        },
        setLocalRoutes: ({ commit, state }, routes) => {
            commit("SET_LOCAL_ROUTES", routes);
        },
        setPath: ({ commit, state }, path) => {
            commit("SET_PATH", path);
        },
        setContentTypes: ({ commit, state }, contentTypes) => {
            commit("SET_CONTENT_TYPES", contentTypes);
        },
        setDragState: ({ commit, state }, result) => {
            commit("SET_DRAGGING", result);
        },
        toggleAdmin: ({ commit, state }) => {
            commit("TOGGLE_ADMIN");
        },
        toggleEditing: ({ commit, state }) => {
            commit("TOGGLE_EDITING");
        },
        setReportGroups: ({ commit, state }, params) => {
            commit("SET_REPORTGROUPS", params);
        }
    },
    modules: {},
    getters: {
        params: state => {
            const params = JSON.parse(JSON.stringify(state.params));
            nextTick(() => {
                //MCL-2538
                //Due to a change in Vuex we need to wait a tick to trigger an update when modifying the state.
                state.params = {}; //Reset the params for next state change
            });
            return params;
        },
        user: state => {
            return state.user;
        },
        isLoggedIn: async (state) => {
            try {
                const response = await Axios.get("/api/v2/user/isLoggedIn");
                SetUser(state, response.data.User);
                //state.user = response.data.User;
                return response.data.IsLoggedIn;
            }
            catch (err) {
                return false;
            }
            //return !!state.token; // non-cookie solution
        },
        isAdmin: state => {
            return state.user.SiteAdmin;
        },
        isEditing: state => {
            return state.admin && state.editing;
        },
        appLoading: state => {
            return state.appLoading;
        },
        router: state => {
            return state.router;
        },
        routes: state => {
            return state.routes;
        },
        localRoutes: state => {
            return state.localRoutes;
        },
        path: state => {
            return state.path;
        },
        contentTypes: state => {
            return state.contentTypes;
        },
        isDragging: state => {
            return state.dragging;
        },
        env: state => {
            return process.env.VUE_APP_ENV;
        },
        reportGroups: state => {
            return state.reportGroups;
        }
    }
});
